import { React } from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PassField from "../Inputs/PassField";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import axios from "../../axios";
import Swal from "sweetalert2";

export default function SignupContent() {
  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    email: Yup.string().email("Invalid email").required("Required"),
    password: Yup.string()
      .min(8, "Password must contain atleast 8 characters")
      .required("Required"),
  });
  const navigate = useNavigate();

  const createAccount = (values, setSubmitting) => {
    axios
      .post("/signup", values)
      .then((response) => {
        if (response.data) {
          if (response.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Account Created Successfully!",
              showConfirmButton: false,
              timer: 2000,
              padding: "2em",
              allowOutsideClick: false,
            }).then((result) => {
              if (result.dismiss === Swal.DismissReason.timer) {
                navigate("/login");
              }
            });
          } else {
            toast.warn("No response from server");
            setSubmitting(false);
          }
        }
      })
      .catch((error) => {
        if (error.response?.data?.email) {
          toast.error(error.response.data.email[0]);
        } else {
          toast.error("Something went wrong");
          console.log(error);
        }
        setSubmitting(false);
      });
  };

  return (
    <div className="row g-0 min-vh-100 align-items-center justify-content-center pt-md-0 pt-5">
      <div className="col-md-8 p-lg-5 p-0">
        <h1 className="mb-4 text-center">Get Started!</h1>
        <Formik
          initialValues={{
            firstName: "",
            lastName: "",
            email: "",
            password: "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) =>
            createAccount(values, setSubmitting)
          }
        >
          {({ values, handleChange, handleSubmit, isSubmitting }) => (
            <Form className="forms px-lg-5 px-4" onSubmit={handleSubmit}>
              <div className="mb-3">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  name="firstName"
                  placeholder="Enter your first name"
                  value={values.firstName}
                  onChange={handleChange}
                  disabled={isSubmitting}
                />
                <ErrorMessage
                  name="firstName"
                  component="p"
                  className="error-message"
                />
              </div>
              <div className="mb-3">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  name="lastName"
                  placeholder="Enter your last name"
                  value={values.lastName}
                  onChange={handleChange}
                  disabled={isSubmitting}
                />
                <ErrorMessage
                  name="lastName"
                  component="p"
                  className="error-message"
                />
              </div>
              <div className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  value={values.email}
                  onChange={handleChange}
                  disabled={isSubmitting}
                />
                <ErrorMessage
                  name="email"
                  component="p"
                  className="error-message"
                />
              </div>
              <PassField
                placeholder="Enter your password"
                name="password"
                value={values.password}
                onChange={handleChange}
                isSubmitting={isSubmitting}
              />
              <Button
                type="submit"
                variant="primary"
                className="btn-full-width my-3"
                disabled={isSubmitting}
              >
                Create Account
                {isSubmitting && (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="ms-2"
                  />
                )}
              </Button>
              <p className="link-font-size">
                Already have an account?
                <Link
                  to={"/login"}
                  className="link-btn ms-1"
                  style={{ pointerEvents: isSubmitting ? "none" : "" }}
                >
                  Let's Login
                </Link>
              </p>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}
